import React, { useEffect, useRef, useState } from "react";
import "./PropertyList.css";
import column from "../../Images/Vector (9).png";
import grid from "../../Images/Group 1171279337.png";
import grid2 from "../../Images/Group 1171279337 (1).png";
import noimage from "../../Images/common_Image.jpg";
import redHeart from "../../Images/red-heart.png";
import heart from "../../Images/Vector (10).png";
import dropdown from "../../Images/Vector (8).png";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { GoDotFill } from "react-icons/go";
import Header from "../../Layout/Header";
import Sidebar from "../../Layout/Sidebar";
import WhatsAppButton from "../../Component/WhatsAppButton";
import HomeService from "../../Services/HomeService";
import { floors } from "../Community/Helper";
import MediaSlider from "./MediaSlider";

const NewPropertyList = () => {
  const [properties, setProperties] = useState([]);
  const [userId, setUserId] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [show, setshow] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [userAccecebilityStatus, setUserAccecebilityStatus] = useState(null);
  const [propertyType, setPropertyType] = useState([]);
  const [city, setCity] = useState([]);
  const [cityWiseLocality, setCityWiseLocality] = useState([]);
  const [cityWiseAppartment, setCityWiseAppartment] = useState([]);
  const [isPriceFilterActive, setIsPriceFilterActive] = useState(false);
  const [isOpenMedia, setIsOpenMedia] = useState(false);
  const [propertyImages, setPropertyImages] = useState([]);

  // Search states for dropdowns
  const [localitySearchTerm, setLocalitySearchTerm] = useState("");
  const [apartmentSearchTerm, setApartmentSearchTerm] = useState("");
  const [showLocalityDropdown, setShowLocalityDropdown] = useState(false);
  const [showApartmentDropdown, setShowApartmentDropdown] = useState(false);

  // Refs for dropdowns
  const localityRef = useRef(null);
  const apartmentRef = useRef(null);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const limit = 25;

  const location = useLocation();
  const navigate = useNavigate();
  const cityId = location?.state?.cityId || null;
  const loggedInUserId = location?.state?.loggedInUserId;

  // Price range state
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(0);
  const [dragging, setDragging] = useState(null);
  const sliderRef = useRef(null);

  const [filterData, setFilterData] = useState({
    userId: loggedInUserId || "",
    cityId: cityId || "",
    propertyType: "",
    propertyFor: "",
    locality: "",
    address: "",
    area: "",
    unit: "",
    bhk: "",
    floor: "",
    aptName: "",
    phoneNo: "",
    minArea: "",
    maxArea: "",
    name: "",
    features: [],
  });

  const [searchDataOnTheGo, setSearchDataOnTheGo] = useState({});

  // Constants
  const availableFor = [
    { name: "Sale", value: "sale" },
    { name: "Rent", value: "rent" },
  ];

  const salePriceOptions = [
    75000, 100000, 500000, 1000000, 2000000, 3000000, 5000000, 7500000,
    10000000, 20000000, 50000000, 100000000, 250000000, 500000000, 1000000000,
    1500000000, 2000000000,
  ];
  const rentPriceOptions = [
    10000, 50000, 75000, 100000, 500000, 1000000, 2000000, 3000000, 5000000,
    7500000, 10000000,
  ];
  const [priceOptions, setPriceOptions] = useState(salePriceOptions);

  // Helper functions
  const getSliderConfig = () => {
    if (filterData.propertyFor === "rent") {
      return { min: 0, max: 7500000, step: 500000 };
    } else {
      return { min: 0, max: 2000000000, step: 1000000 };
    }
  };

  const formatValue = (val) => {
    if (val >= 10000000) return `₹${(val / 10000000).toFixed(2)} Cr`;
    else if (val >= 100000) return `₹${(val / 100000).toFixed(2)} L`;
    else if (val >= 1000) return `₹${(val / 1000).toFixed(0)}K`;
    else return `₹${val}`;
  };

  const formatDateWithOrdinal = (isoDateString) => {
    if (!isoDateString) return "N/A";
    const date = new Date(isoDateString);
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();
    const month = date.toLocaleString("en-US", {
      month: "long",
      timeZone: "UTC",
    });
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return "th";
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };
    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };

  // Filtered lists based on search term
  const filteredLocalities = cityWiseLocality.filter((item) =>
    item.name?.toLowerCase().includes(localitySearchTerm.toLowerCase()),
  );

  const filteredApartments = cityWiseAppartment.filter((item) =>
    item.aptName?.toLowerCase().includes(apartmentSearchTerm.toLowerCase()),
  );

  // API Calls
  const fetchNewProperties = async (page = 1) => {
    try {
      setLoading(true);
      const res = await HomeService.getNewPropertyList(page);
      console.log("newProperty", res);
      if (res.status) {
        setProperties(res?.data || []);
        if (res?.pagination) {
          setTotalPages(res.pagination.totalPages);
          setTotalItems(res.pagination.totalProperties);
          setCurrentPage(res.pagination.currentPage);
        }
      } else {
        toast.error(res?.message);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching new properties:", error);
      toast.error(error.message);
      setLoading(false);
    }
  };

  const fetchCity = async (uid) => {
    try {
      const res = await HomeService?.getCities({ userId: uid });
      if (res?.status) {
        setCity(res.data);
      }
    } catch (error) {
      console.error("Error fetching city:", error);
    }
  };

  const fetchLocality = async (id) => {
    try {
      const res = await HomeService.getLocalitiesByCity(id);
      if (res?.status) {
        setCityWiseLocality(res?.data);
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  const fetchPropertyType = async () => {
    try {
      const res = await HomeService.getPropertyTypes();
      if (res?.status) {
        setPropertyType(res.data);
      }
    } catch (error) {
      console.error("Error fetching property types:", error);
    }
  };

  const getLoginProfile = async () => {
    try {
      const res = await HomeService.getLoginProfile();
      console.log("userDetails", res);
      if (!res.status) {
        navigate("/profile");
        return;
      }
      if (res?.status) {
        const userData = res.data;
        setUserId(userData?._id);
        setFilterData((prev) => ({
          ...prev,
          userId: userData?._id,
        }));
        await fetchCity(userData?._id);
        if (cityId || userData?.multiSubscribedCities[0]?._id) {
          const cityToFetch = cityId || userData?.multiSubscribedCities[0]?._id;
          fetchLocality(cityToFetch);
          getAppartmentByCityId(cityToFetch);
        }
      }
    } catch (error) {
      console.error("Error in getLoginProfile:", error);
      toast.error("Failed to load user profile");
    }
  };

  const getLocalityByCityId = async (id) => {
    try {
      const res = await HomeService.getLocalitiesByCity(id);
      if (res?.status) {
        setCityWiseLocality(res?.data);
      } else {
        setCityWiseLocality([]);
      }
    } catch (error) {
      console.error("Failed to fetch Localities:", error);
      setCityWiseLocality([]);
    }
  };

  const getAppartmentByCityId = async (id) => {
    try {
      const res = await HomeService.getAppartmentByCity(id);
      if (res?.status) {
        setCityWiseAppartment(res?.data);
      } else {
        setCityWiseAppartment([]);
      }
    } catch (error) {
      console.error("Failed to fetch Appartment:", error);
      setCityWiseAppartment([]);
    }
  };

  // Filter function
  const handleSearchOnTheGo = async (e, searchData, page = 1) => {
    e && e.preventDefault();
    const updatedSearchData = {
      ...searchDataOnTheGo,
      ...searchData,
    };
    setSearchDataOnTheGo(updatedSearchData);

    const data = {
      userId: userId,
      cityId: updatedSearchData.cityId || filterData.cityId,
      propertyType: updatedSearchData.propertyType,
      propertyFor: updatedSearchData.propertyFor,
      locality: updatedSearchData.locality,
      address: updatedSearchData.address,
      area: updatedSearchData.area,
      unit: updatedSearchData?.unit,
      bhk: updatedSearchData.bhk,
      floor: updatedSearchData.floor,
      aptName: updatedSearchData?.aptName,
      phoneNo: updatedSearchData?.phoneNo,
      minArea: updatedSearchData?.minArea,
      maxArea: updatedSearchData?.maxArea,
      name: updatedSearchData?.name,
      features: updatedSearchData?.features,
    };
    console.log("filter", data);

    if (isPriceFilterActive) {
      data.minPrice = updatedSearchData.minPrice || minValue;
      data.maxPrice = updatedSearchData.maxPrice || maxValue;
    }

    try {
      // setLoading(true);
      const response = await HomeService.filterInNewProperties(data, page);
      if (response?.data && Array.isArray(response.data)) {
        setProperties(response.data);
        if (response?.pagination) {
          setTotalPages(response.pagination.totalPages);
          setTotalItems(response.pagination.totalProperties);
          setCurrentPage(response.pagination.currentPage);
        }
      }
      setLoading(false);
    } catch (error) {
      console.error("Search error:", error);
      toast.error("Search failed");
      setLoading(false);
    }
  };

  const handleFilterChange = (field, value) => {
    if (field === "cityId" && value) {
      getLocalityByCityId(value);
      getAppartmentByCityId(value);
      setFilterData((prev) => ({
        ...prev,
        locality: "",
        aptName: "",
      }));
    }

    if (field !== "cityId" && !filterData.cityId && !value) {
      toast.warning("Please select a city first");
      return;
    }

    setFilterData((prev) => ({ ...prev, [field]: value }));

    if (field === "cityId" || filterData.cityId || value) {
      handleSearchOnTheGo(null, { [field]: value }, 1);
    }
  };

  const handleClearAll = () => {
    setFilterData({
      userId: userId,
      cityId: "",
      propertyType: "",
      propertyFor: "",
      locality: "",
      address: "",
      area: "",
      bhk: "",
      floor: "",
      priceRange: "",
      aptName: "",
      phoneNo: "",
      minArea: "",
      maxArea: "",
      name: "",
      features: [],
    });
    setIsPriceFilterActive(false);
    setMinValue(0);
    setMaxValue(0);
    setCityWiseLocality([]);
    setCityWiseAppartment([]);
    setCurrentPage(1);
    setLocalitySearchTerm("");
    setApartmentSearchTerm("");
    setSearchDataOnTheGo({});
    fetchNewProperties(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (Object.keys(searchDataOnTheGo).length > 0 || filterData.cityId) {
      handleSearchOnTheGo(null, searchDataOnTheGo, page);
    } else {
      fetchNewProperties(page);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Price slider functions
  const valueToPercent = (val) => {
    const { min, max } = getSliderConfig();
    return ((val - min) / (max - min)) * 100;
  };

  const percentToValue = (percent) => {
    const { min, max } = getSliderConfig();
    return min + ((max - min) * percent) / 100;
  };

  const handleMouseMove = (e) => {
    if (!dragging) return;
    const rect = sliderRef.current.getBoundingClientRect();
    let percent = ((e.clientX - rect.left) / rect.width) * 100;
    percent = Math.max(0, Math.min(100, percent));

    let rawVal = percentToValue(percent);
    let dynamicStep =
      rawVal > 10000000
        ? 10000000
        : rawVal > 100000
          ? 1000000
          : getSliderConfig().step;
    let val = Math.round(rawVal / dynamicStep) * dynamicStep;
    val = Math.min(getSliderConfig().max, Math.max(getSliderConfig().min, val));

    if (dragging === "min") {
      if (val >= maxValue) val = maxValue - dynamicStep;
      setMinValue(val);
    } else if (dragging === "max") {
      if (val <= minValue) val = minValue + dynamicStep;
      setMaxValue(val);
    }
  };

  const handleMouseUp = () => {
    setDragging(null);
    if (isPriceFilterActive) {
      handleSearchOnTheGo(null, { minPrice: minValue, maxPrice: maxValue }, 1);
    }
  };

  // Wishlist handler
  const handleClick = async (propertyId) => {
    if (!userId) {
      toast.error("User not logged in");
      return;
    }
    try {
      const data = { userId, propertyId };
      const res = await HomeService.addToWishList(data);
      if (res?.status) {
        setIsClicked(!isClicked);
        toast.success(res?.message);
        if (Object.keys(searchDataOnTheGo).length > 0 || filterData.cityId) {
          await handleSearchOnTheGo(null, {}, currentPage);
        } else {
          await fetchNewProperties(currentPage);
        }
      } else {
        toast.error(res?.message || "Failed to add to wishlist");
      }
    } catch (error) {
      console.error("Error adding property to wishlist:", error);
      toast.error("Failed to add property to wishlist");
    }
  };

  // Share function
  const handleShareClick = (property) => {
    const subject = `${property.propertytype?.propertyType} in ${property.locality?.name}`;
    const body =
      `I am interested in the ${property.propertytype?.propertyType} at ${property.address}.` +
      `%0D%0AFound information from Winners`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(
      subject,
    )}&body=${body}`;
    const link = document.createElement("a");
    link.href = mailtoLink;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openWhatsAppLink = (e, phoneNumber, textMessage) => {
    e.preventDefault();
    const isMobile =
      /iPhone|Android|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );
    const encodedText = encodeURIComponent(textMessage);
    const link = isMobile
      ? `https://wa.me/${phoneNumber}?text=${encodedText}`
      : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedText}`;
    const a = document.createElement("a");
    a.href = link;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.click();
  };

  // Export functions
  const downloadExcel = () => {
    if (properties.length === 0) {
      toast.error("No data to export");
      return;
    }
    const visibleProperties = properties.filter(
      (property) => property.visibility === true,
    );
    if (visibleProperties.length === 0) {
      toast.error("No visible properties to export");
      return;
    }
    const worksheetData = visibleProperties.map((row) => ({
      "Property For": row?.propertyFor || "",
      Appartment_Name: row?.aptName,
      Locality: row?.locality?.name || "",
      Address: row?.address || "",
      Area: `${row?.area || ""} ${row?.unit || ""}`,
      Floor: row?.floor || "",
      BHK: row?.bhk || "",
      Owner_Name: row?.ownerName || "",
      Owner_Number: row?.phoneNo || "",
      Price: `${row?.price || ""} ${row?.priceUnit || ""}`,
    }));
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "New Properties");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "new_property_list.xlsx");
  };

  const downloadPDF = () => {
    if (properties.length === 0) {
      toast.error("No data to export");
      return;
    }
    const visibleProperties = properties.filter(
      (property) => property.visibility === true,
    );
    if (visibleProperties.length === 0) {
      toast.error("No visible properties to export");
      return;
    }
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(16);
    doc.text("New Property List", 14, 20);
    const tableColumn = [
      "Property_For",
      "Appartment_Name",
      "Locality",
      "Address",
      "Area",
      "Floor",
      "BHK",
      "Owner_Name",
      "Owner_Number",
      "Price",
    ];
    const tableRows = visibleProperties.map((row) => [
      row?.propertyFor || "",
      row?.aptName || "",
      row?.locality?.name || "",
      row?.address || "",
      [row?.area, row?.unit].filter(Boolean).join(" "),
      row?.floor || "",
      row?.bhk || "",
      row?.ownerName || "",
      row?.phoneNo || "",
      [row?.price, row?.priceUnit].filter(Boolean).join(" "),
    ]);
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 30,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185] },
    });
    doc.save("new_property_list.pdf");
  };

  // Render price slider
  const renderPriceSlider = () => {
    const minPercent = valueToPercent(minValue);
    const maxPercent = valueToPercent(maxValue);

    return (
      <div className="form_field_property">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "10px",
          }}
        >
          <label className="filter_property_label" style={{ marginBottom: 0 }}>
            Price Filter
          </label>
          <input
            disabled={!filterData.cityId}
            type="checkbox"
            checked={isPriceFilterActive}
            onChange={(e) => {
              setIsPriceFilterActive(e.target.checked);
              if (e.target.checked) {
                handleSearchOnTheGo(
                  null,
                  { minPrice: minValue, maxPrice: maxValue },
                  1,
                );
              } else {
                handleSearchOnTheGo(
                  null,
                  { minPrice: null, maxPrice: null },
                  1,
                );
              }
            }}
          />
        </div>
        {isPriceFilterActive && (
          <div className="filter_input_div">
            <div style={{ margin: "40px 10px 10px 10px" }}>
              <div
                ref={sliderRef}
                style={{
                  position: "relative",
                  height: 8,
                  background: "#ddd",
                  borderRadius: 4,
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    height: 8,
                    background: "#007bff",
                    borderRadius: 4,
                    left: `${minPercent}%`,
                    width: `${maxPercent - minPercent}%`,
                    top: 0,
                  }}
                />
                <div
                  onMouseDown={() => setDragging("min")}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: `${minPercent}%`,
                    transform: "translate(-50%, -50%)",
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    backgroundColor: "#007bff",
                    boxShadow: "0 0 5px #007bff",
                    cursor: "pointer",
                    zIndex: dragging === "min" ? 2 : 1,
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: -30,
                      left: "50%",
                      transform: "translateX(-50%)",
                      color: "#fff",
                      fontWeight: "500",
                      fontSize: 10,
                      whiteSpace: "nowrap",
                      userSelect: "none",
                      background: "#333",
                      padding: "5px 10px",
                      borderRadius: "4px",
                    }}
                  >
                    {formatValue(minValue)}
                  </div>
                </div>
                <div
                  onMouseDown={() => setDragging("max")}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: `${maxPercent}%`,
                    transform: "translate(-50%, -50%)",
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    backgroundColor: "#007bff",
                    boxShadow: "0 0 5px #007bff",
                    cursor: "pointer",
                    zIndex: dragging === "max" ? 2 : 1,
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: -30,
                      left: "50%",
                      transform: "translateX(-50%)",
                      color: "#fff",
                      fontWeight: "500",
                      fontSize: 10,
                      whiteSpace: "nowrap",
                      userSelect: "none",
                      background: "#333",
                      padding: "5px 10px",
                      borderRadius: "4px",
                    }}
                  >
                    {formatValue(maxValue)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  // Render filter field
  const renderFilterField = (
    label,
    field,
    type = "select",
    options = [],
    placeholder = "",
  ) => {
    const isDisabled = field !== "cityId" && !filterData.cityId;

    return (
      <div className="form_field_property">
        <label className="filter_property_label">{label}</label>
        <div className="filter_input_div">
          {type === "select" ? (
            <select
              className="filter_input"
              value={filterData[field] || ""}
              onChange={(e) => handleFilterChange(field, e.target.value)}
              disabled={isDisabled}
              style={{ backgroundColor: isDisabled ? "#f5f5f5" : "white" }}
            >
              <option value="">
                {isDisabled ? "Select city first" : `Select ${label}`}
              </option>
              {options.map((option) => (
                <option
                  key={option._id || option.value}
                  value={option._id || option.value}
                >
                  {option.name || option.propertyType || option.aptName}
                </option>
              ))}
            </select>
          ) : (
            <input
              className="filter_input"
              placeholder={isDisabled ? "Select city first" : placeholder}
              value={filterData[field] || ""}
              onChange={(e) => handleFilterChange(field, e.target.value)}
              disabled={isDisabled}
              style={{ backgroundColor: isDisabled ? "#f5f5f5" : "white" }}
            />
          )}
        </div>
      </div>
    );
  };

  // Owner names for autocomplete
  const [ownerNames, setOwnerNames] = useState([]);
  const [fetchOwnerNamesLoading, setFetchOwnerNamesLoading] = useState(false);
  const [isOwnerNameInputClicked, setIsOwnerNameInputClicked] = useState(false);
  const ownerRef = useRef();

  const fetchOwnerNames = async (params = filterData?.name) => {
    setFetchOwnerNamesLoading(true);
    try {
      const res = await HomeService?.getOwnerNames(params);
      if (res?.status) {
        setOwnerNames(res?.data?.slice(0, 500));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setFetchOwnerNamesLoading(false);
    }
  };

  // Effects
  useEffect(() => {
    if (cityId) {
      getLoginProfile();
      handleFilterChange("cityId", cityId);
    } else {
      fetchNewProperties(1);
    }
  }, []);

  useEffect(() => {
    fetchOwnerNames();
  }, [filterData?.name]);

  useEffect(() => {
    if (dragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    } else {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [dragging, minValue, maxValue, isPriceFilterActive]);

  useEffect(() => {
    if (filterData?.cityId) {
      fetchLocality(filterData?.cityId);
      getAppartmentByCityId(filterData?.cityId);
    } else {
      setCityWiseLocality([]);
      setCityWiseAppartment([]);
    }
  }, [filterData?.cityId]);

  useEffect(() => {
    filterData?.propertyFor === "rent"
      ? setPriceOptions(rentPriceOptions)
      : setPriceOptions(salePriceOptions);
  }, [filterData?.propertyFor]);

  useEffect(() => {
    setMinValue(getSliderConfig().min);
    setMaxValue(getSliderConfig().max);
  }, [filterData]);

  useEffect(() => {
    if (isPriceFilterActive) {
      handleSearchOnTheGo(null, { minPrice: minValue, maxPrice: maxValue }, 1);
    }
  }, [minValue, maxValue, isPriceFilterActive]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (localityRef.current && !localityRef.current.contains(event.target)) {
        setShowLocalityDropdown(false);
      }
      if (
        apartmentRef.current &&
        !apartmentRef.current.contains(event.target)
      ) {
        setShowApartmentDropdown(false);
      }
      if (ownerRef.current && !ownerRef.current.contains(event.target)) {
        setIsOwnerNameInputClicked(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const initializeData = async () => {
      try {
        const fetchUserAccecibilityToDownload = async () => {
          try {
            const res = await HomeService.getUserAccecebilityToDownload();
            if (res?.status) {
              setUserAccecebilityStatus(res?.data?.visibilityAcess);
            }
          } catch (error) {
            console.error("Error fetching accessibility:", error);
          }
        };
        await fetchUserAccecibilityToDownload();
        await fetchPropertyType();
        await getLoginProfile();
        window.scrollTo({ top: 0, behavior: "instant" });
      } catch (error) {
        console.error("Error initializing data:", error);
        toast.error("Failed to initialize data");
      }
    };
    initializeData();
  }, []);

  // Pagination component
  const Pagination = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <div>
        <div
          className="pagination-container"
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            gap: "8px",
          }}
        >
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn"
            style={{
              padding: "8px 12px",
              border: "1px solid #ddd",
              borderRadius: "4px",
              backgroundColor: currentPage === 1 ? "#f5f5f5" : "white",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            Previous
          </button>
          {pageNumbers.map((number) => (
            <button
              key={number}
              onClick={() => handlePageChange(number)}
              className={`pagination-btn ${currentPage === number ? "active" : ""}`}
              style={{
                padding: "8px 12px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                backgroundColor: currentPage === number ? "#007bff" : "white",
                color: currentPage === number ? "white" : "black",
                cursor: "pointer",
              }}
            >
              {number}
            </button>
          ))}
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn"
            style={{
              padding: "8px 12px",
              border: "1px solid #ddd",
              borderRadius: "4px",
              backgroundColor: currentPage === totalPages ? "#f5f5f5" : "white",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            Next
          </button>
        </div>
        <div style={{ display: "block" }} className="pagination-info">
          Showing page {currentPage} of {totalPages}
        </div>
      </div>
    );
  };

  const firstImage = (imageArray) => {
    return (
      imageArray?.find((url) => url.match(/\.(jpg|jpeg|png|gif|webp)$/i)) ||
      noimage
    );
  };

  const onClose = () => {
    setIsOpenMedia(false);
  };

  return (
    <>
      <WhatsAppButton phoneNumber="918009903561" textMessge="Hello" />
      <Header collapse={collapse} setCollapse={setCollapse} />
      {isOpenMedia && (
        <MediaSlider mediaArray={propertyImages} onClose={onClose} />
      )}
      <Sidebar />
      <div className={collapse ? "layout_collapsed" : ""}>
        <div className="uni_wrapper bg">
          <div className="uni_container5">
            <div className="property_list_screen_div">
              {/* Filter Button and City Tabs */}
              <div className="coulmn_row_div_wrapper">
                <div className="column_row_div column_row_div5662">
                  <div className="column_div55" onClick={() => setshow(!show)}>
                    <div className="column_div">
                      <i className="fa-solid fa-filter"></i>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      overflowX: "auto",
                      width: "100%",
                    }}
                  >
                    {city.map((item, key) => (
                      <div
                        key={key}
                        style={{
                          maxWidth: "fit-content",
                          padding: "5px 10px",
                          cursor: item.isSubscribedByUser
                            ? "pointer"
                            : "default",
                          border: "solid 1px #023269",
                          backgroundColor: item.isSubscribedByUser
                            ? "#023269"
                            : "#f3f1f2",
                          color: item.isSubscribedByUser
                            ? "#ffffff"
                            : "#023269",
                          fontSize: "12px",
                          width: "fit-content",
                          display: "flex",
                          justifyContent: "start",
                          alignItems: "center",
                          borderRadius: "16px",
                          boxShadow: "0px 0px 4px 0px rgba(2, 50, 105, 0.33)",
                        }}
                        onClick={() => {
                          if (item.isSubscribedByUser) {
                            handleFilterChange("cityId", item._id);
                          } else {
                            toast.warning(
                              "You are not subscribed to this city",
                            );
                          }
                        }}
                      >
                        {!item.isSubscribedByUser && (
                          <i
                            className="fa-solid fa-lock"
                            style={{ color: "#023269", marginRight: "4px" }}
                          ></i>
                        )}
                        <p
                          style={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item.name}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Header with Title and Export Buttons */}
              <div className="list_down_pdf_wrp">
                <h5 className="property_list_title">New Properties List</h5>
                {/* <div>
                  {userAccecebilityStatus && (
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        gap: "15px",
                      }}
                    >
                      <button onClick={downloadPDF} className="export-btn">
                        <i
                          className="fa-solid fa-download"
                          style={{ marginTop: "5px" }}
                        ></i>
                        <span style={{ fontWeight: "600" }}>PDF</span>
                      </button>
                      <button onClick={downloadExcel} className="export-btn">
                        <i
                          className="fa-solid fa-download"
                          style={{ marginTop: "5px" }}
                        ></i>
                        <span style={{ fontWeight: "600" }}>Excel</span>
                      </button>
                    </div>
                  )}
                </div> */}
              </div>

              <div className="property_list_div_wrapper">
                {/* Property Grid */}
                <div className="property_grid_div">
                  {loading ? (
                    <div className="property_grid_div text-center p-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2">Loading properties...</p>
                    </div>
                  ) : properties.length === 0 ? (
                    <div className="no_data_message">
                      No New Properties found
                    </div>
                  ) : (
                    properties.map((property, index) => (
                      <div
                        className="property_grid_one property_grid_new_class "
                        key={property._id || index}
                        // style={{ height: "100%" }}
                      >
                        <div className="propety_grid_img">
                          <img
                            onClick={() => {
                              setIsOpenMedia(true);
                              setPropertyImages(property?.images);
                            }}
                            className="propety_grid_img_display"
                            // src={property?.property?.images?.[0] || noimage}
                            src={firstImage(property?.images)}
                            alt="Property"
                            style={{ cursor: "pointer" }}
                          />
                          {/* <div
                            className="heart_div_2"
                            onClick={() =>
                              handleClick(property?.propertyId || property?._id)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={property?.isFavourite ? redHeart : heart}
                              alt="Favorite"
                              style={{ width: "20px" }}
                            />
                          </div> */}
                          {property?.images?.length > 0 && (
                            <div
                              style={{
                                position: "absolute",
                                height: "20px",
                                borderRadius: "20px",
                                // backgroundColor: "white",
                                bottom: "5%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                left: "5%",
                                backgroundColor: "black",
                              }}
                            >
                              {property?.images?.map((e, i) => {
                                return <GoDotFill style={{ color: "white" }} />;
                              })}
                            </div>
                          )}
                        </div>
                        <div className="property_grid_data property_grid_data_new">
                          <div className="profile_row_ps">
                            {property?.name && (
                              <div className="profile_left_ps">
                                <div className="profile_avatar_ps">
                                  {property?.name?.slice(0, 1)?.toUpperCase()}
                                </div>
                                <span className="profile_name_ps">
                                  {property?.name}
                                </span>
                              </div>
                            )}
                            <div className="profile_right_ps">
                              <i className="fa-regular fa-calendar calendar_icon_ps"></i>
                              <span className="profile_date_ps">
                                {formatDateWithOrdinal(property?.createdOn)}
                              </span>
                            </div>
                          </div>
                          <h5 className="pro_name_ps">
                            {property?.bhk
                              ? `${property?.bhk || ""} bhk ${
                                  property?.propertytype?.propertyType || ""
                                } ${property?.propertyFor || ""} in ${
                                  property?.locality?.name || ""
                                } ${property?.city?.name || ""}`
                              : `${property?.propertytype?.propertyType || ""} ${
                                  property?.propertyFor || ""
                                } in ${property?.locality?.name || ""} ${
                                  property?.city?.name || ""
                                }`}
                          </h5>
                          <div className="property_grid_content">
                            <div className="property_data">
                              <div className="property_para_div">
                                <p className="property_data_para">City:</p>
                                <p className="property_data_para2">
                                  {property?.city?.name || "N/A"}
                                </p>
                              </div>
                              <div className="property_para_div">
                                <p className="property_data_para">Locality:</p>
                                <p className="property_data_para2">
                                  {property?.locality?.name || "N/A"}
                                </p>
                              </div>
                              <div className="property_para_div">
                                <p className="property_data_para">BHK:</p>
                                <p className="property_data_para2">
                                  {property?.bhk || "N/A"}
                                </p>
                              </div>
                            </div>
                            <div className="property_data">
                              <div className="property_para_div">
                                <p className="property_data_para">Address:</p>
                                <p className="property_data_para2">
                                  {property?.address || "N/A"}
                                </p>
                              </div>
                              <div className="property_para_div">
                                <p className="property_data_para">
                                  Property Type:
                                </p>
                                <p className="property_data_para2">
                                  {property?.propertytype?.propertyType ||
                                    property?.propertyType ||
                                    "N/A"}
                                </p>
                              </div>
                              <div className="property_para_div">
                                <p className="property_data_para">Contact:</p>
                                <p className="property_data_para2">
                                  {property?.phoneNo || "N/A"}
                                </p>
                              </div>
                            </div>
                            <div className="property_data">
                              <div className="property_para_div">
                                <p className="property_data_para">Area:</p>
                                <p className="property_data_para2">
                                  {property?.area || "N/A"}{" "}
                                  {property?.unit ? property?.unit : ""}
                                </p>
                              </div>
                              <div className="property_para_div">
                                <p className="property_data_para">Price:</p>
                                <p className="property_data_para2">
                                  {property?.price || "N/A"}{" "}
                                  {property?.priceUnit === "TH"
                                    ? "Thousand"
                                    : property?.priceUnit === "LKH"
                                      ? "Lakh"
                                      : property?.priceUnit === "CR"
                                        ? "Crore"
                                        : property?.priceUnit || ""}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div style={{ marginTop: "60px", marginLeft: "65%" }}>
                            <span
                              style={{
                                color: "#003466",
                                cursor: "pointer",
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                              onClick={() => {
                                localStorage.setItem(
                                  "propertyId",
                                  property?._id,
                                );
                                window.open("/single-property", "_blank");
                              }}
                            >
                              View Property Details
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                  <div style={{ width: "100%" }}>
                    {totalPages > 1 && <Pagination />}
                  </div>
                </div>

                {/* Pagination */}
                {/* {totalPages > 1 && <Pagination />} */}

                {/* Filter Panel */}
                <div
                  className="filter_property_div"
                  style={{ padding: "10px 10px" }}
                >
                  <form>
                    {/* City Dropdown */}
                    <div className="form_field_property">
                      <label className="filter_property_label">City</label>
                      <div className="filter_input_div">
                        <select
                          className="filter_input"
                          value={filterData?.cityId}
                          onChange={(e) =>
                            handleFilterChange("cityId", e.target.value)
                          }
                        >
                          <option value="">Select City</option>
                          {city?.map((option) => (
                            <option value={option._id} key={option._id}>
                              {option?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Property Type Dropdown */}
                    <div className="form_field_property">
                      <label className="filter_property_label">
                        Property Type
                      </label>
                      <div className="filter_input_div">
                        <select
                          className="filter_input"
                          value={filterData?.propertyType}
                          onChange={(e) =>
                            handleFilterChange("propertyType", e.target.value)
                          }
                          disabled={!filterData.cityId}
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        >
                          <option value="">
                            {!filterData.cityId
                              ? "Select city first"
                              : "Select Property Type"}
                          </option>
                          {propertyType?.map((option) => (
                            <option value={option._id} key={option._id}>
                              {option?.propertyType}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Available For Dropdown */}
                    <div className="form_field_property">
                      <label className="filter_property_label">
                        Available For
                      </label>
                      <div className="filter_input_div">
                        <select
                          className="filter_input"
                          value={filterData?.propertyFor}
                          onChange={(e) =>
                            handleFilterChange("propertyFor", e.target.value)
                          }
                          disabled={!filterData.cityId}
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        >
                          <option value="">
                            {!filterData.cityId
                              ? "Select city first"
                              : "Select Available For"}
                          </option>
                          {availableFor?.map((option) => (
                            <option value={option.value} key={option.value}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Locality Dropdown with Search */}
                    <div className="form_field_property" ref={localityRef}>
                      <label className="filter_property_label">Locality</label>
                      <div className="filter_input_div">
                        <div className="custom-dropdown">
                          <input
                            type="text"
                            className="filter-input"
                            placeholder={
                              !filterData.cityId
                                ? "Select city first"
                                : filterData.locality
                                  ? cityWiseLocality.find(
                                      (item) =>
                                        item._id === filterData.locality,
                                    )?.name || "Search locality..."
                                  : "Search locality..."
                            }
                            value={
                              showLocalityDropdown
                                ? localitySearchTerm
                                : filterData.locality
                                  ? cityWiseLocality.find(
                                      (item) =>
                                        item._id === filterData.locality,
                                    )?.name || ""
                                  : ""
                            }
                            onChange={(e) => {
                              setLocalitySearchTerm(e.target.value);
                              setShowLocalityDropdown(true);
                            }}
                            onClick={() => {
                              if (filterData.cityId) {
                                setShowLocalityDropdown(!showLocalityDropdown);
                                setLocalitySearchTerm("");
                              }
                            }}
                            disabled={!filterData.cityId}
                            style={{
                              // backgroundColor: !filterData.cityId
                              //   ? "white"
                              //   : "white",
                              cursor: !filterData.cityId
                                ? "not-allowed"
                                : "text",
                              borderRadius: "10px",
                            }}
                          />
                          {showLocalityDropdown && filterData.cityId && (
                            <div
                              className="dropdown-list"
                              style={{
                                overflow: "auto",
                                scrollbarWidth: "none",
                              }}
                            >
                              <div
                                className={`dropdown-item ${filterData.locality === "" ? "selected" : ""}`}
                                onClick={() => {
                                  handleFilterChange("locality", "");
                                  setShowLocalityDropdown(false);
                                  setLocalitySearchTerm("");
                                }}
                              >
                                Select Locality
                              </div>
                              {filteredLocalities.length > 0 ? (
                                filteredLocalities.map((option) => (
                                  <div
                                    style={{ fontSize: "12px" }}
                                    key={option._id}
                                    className={`dropdown-item ${filterData.locality === option._id ? "selected" : ""}`}
                                    onClick={() => {
                                      handleFilterChange(
                                        "locality",
                                        option._id,
                                      );
                                      setShowLocalityDropdown(false);
                                      setLocalitySearchTerm("");
                                    }}
                                  >
                                    {option.name}
                                  </div>
                                ))
                              ) : (
                                <div className="dropdown-item no-results">
                                  No localities found
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Apartment Name Dropdown */}
                    <div className="form_field_property" ref={apartmentRef}>
                      <label className="filter_property_label">
                        Apartment Name
                      </label>
                      <div className="filter_input_div">
                        <div className="custom-dropdown">
                          <input
                            type="text"
                            className="filter-input"
                            placeholder={
                              !filterData.cityId
                                ? "Select city first"
                                : !filterData?.locality
                                  ? "Select Locality First"
                                  : filterData.aptName
                                    ? filterData.aptName
                                    : "Search apartment..."
                            }
                            value={
                              showApartmentDropdown
                                ? apartmentSearchTerm
                                : filterData.aptName || ""
                            }
                            onChange={(e) => {
                              setApartmentSearchTerm(e.target.value);
                              setShowApartmentDropdown(true);
                            }}
                            onClick={() => {
                              if (filterData.cityId) {
                                setShowApartmentDropdown(
                                  !showApartmentDropdown,
                                );
                                setApartmentSearchTerm("");
                              }
                            }}
                            disabled={
                              !filterData.cityId || !filterData?.locality
                            }
                            style={{
                              // backgroundColor: !filterData.cityId
                              //   ? "white"
                              //   : "white",
                              cursor: !filterData.cityId
                                ? "not-allowed"
                                : "text",
                              borderRadius: "10px",
                            }}
                          />
                          {showApartmentDropdown && filterData.cityId && (
                            <div
                              className="dropdown-list"
                              style={{
                                overflow: "auto",
                                scrollbarWidth: "none",
                              }}
                            >
                              <div
                                className={`dropdown-item ${filterData.aptName === "" ? "selected" : ""}`}
                                onClick={() => {
                                  handleFilterChange("aptName", "");
                                  setShowApartmentDropdown(false);
                                  setApartmentSearchTerm("");
                                }}
                              >
                                Select Apartment
                              </div>
                              {filteredApartments.length > 0 ? (
                                filteredApartments
                                  .filter(
                                    (item) =>
                                      item?.locality?._id ===
                                      filterData?.locality,
                                  )
                                  .map((option, index) => (
                                    <div
                                      style={{ fontSize: "12px" }}
                                      key={index}
                                      className={`dropdown-item ${filterData.aptName === option.aptName ? "selected" : ""}`}
                                      onClick={() => {
                                        handleFilterChange(
                                          "aptName",
                                          option.aptName,
                                        );
                                        setShowApartmentDropdown(false);
                                        setApartmentSearchTerm("");
                                      }}
                                    >
                                      {option.aptName}
                                    </div>
                                  ))
                              ) : (
                                <div className="dropdown-item no-results">
                                  No apartments found
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Owner Phone Number */}
                    {renderFilterField(
                      "Owner Phone Number",
                      "phoneNo",
                      "input",
                      [],
                      "Enter Owner Phone Number",
                    )}

                    {/* Society name / Address */}
                    {renderFilterField(
                      "Society name / Address",
                      "address",
                      "input",
                      [],
                      "Enter address",
                    )}

                    {/* Area */}
                    <div
                      className="form_field_property"
                      style={{ display: "flex" }}
                    >
                      <div style={{ flex: 1, marginRight: "10px" }}>
                        <label className="filter_property_label">
                          Minimum Area
                        </label>
                        <div className="filter_input_div">
                          <input
                            className="filter_input"
                            placeholder={
                              !filterData.cityId
                                ? "Select city first"
                                : "Enter Minimum Area"
                            }
                            value={filterData.minArea}
                            onChange={(e) =>
                              handleFilterChange(
                                "minArea",
                                Number(e.target.value),
                              )
                            }
                            disabled={!filterData.cityId}
                            style={{
                              backgroundColor: !filterData.cityId
                                ? "#f5f5f5"
                                : "white",
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ flex: 1, marginRight: "10px" }}>
                        <label className="filter_property_label">
                          Maximum Area
                        </label>
                        <div className="filter_input_div">
                          <input
                            className="filter_input"
                            placeholder={
                              !filterData.cityId
                                ? "Select city first"
                                : !filterData?.minArea
                                  ? "Enter Minimum area first"
                                  : "Enter Maximum Area"
                            }
                            value={filterData.maxArea}
                            onChange={(e) =>
                              handleFilterChange(
                                "maxArea",
                                Number(e.target.value),
                              )
                            }
                            disabled={
                              !filterData.cityId || !filterData?.minArea
                            }
                            style={{
                              backgroundColor: !filterData.cityId
                                ? "#f5f5f5"
                                : "white",
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Area Unit */}
                    <div style={{ marginTop: "10px" }}>
                      <label className="filter_property_label">Area Unit</label>
                      <div className="filter_input_div">
                        <select
                          disabled={
                            !filterData?.minArea ||
                            !filterData.cityId ||
                            !filterData?.maxArea
                          }
                          className="filter_input"
                          value={filterData?.unit}
                          onChange={(e) =>
                            handleFilterChange("unit", e.target.value)
                          }
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        >
                          <option>--Select Unit--</option>
                          <option value="Feet">Feet</option>
                          <option value="Meter">Meter</option>
                          <option value="Yard">Yard</option>
                        </select>
                      </div>
                    </div>

                    {/* BHK */}
                    <div style={{ marginTop: "10px" }}>
                      <label className="filter_property_label">BHK</label>
                      <div className="filter_input_div">
                        <select
                          disabled={!filterData.cityId}
                          className="filter_input"
                          value={filterData?.bhk}
                          onChange={(e) =>
                            handleFilterChange("bhk", e.target.value)
                          }
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        >
                          <option value="">--Select BHK--</option>
                          {[
                            "0",
                            "1",
                            "1RK",
                            "2",
                            "2RK",
                            ...Array.from({ length: 33 }, (_, i) =>
                              (i + 3).toString(),
                            ),
                          ]?.map((item) => (
                            <option value={item} key={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Floor */}
                    <div style={{ marginTop: "10px" }}>
                      <label className="filter_property_label">Floor</label>
                      <div className="filter_input_div">
                        <select
                          disabled={!filterData.cityId}
                          className="filter_input"
                          value={filterData?.floor}
                          onChange={(e) =>
                            handleFilterChange("floor", e.target.value)
                          }
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        >
                          <option value="">--Select Floor--</option>
                          {floors?.map((item) => (
                            <option value={item} key={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Owner Name with Autocomplete */}
                    <div
                      style={{
                        flex: 1,
                        marginTop: "10px",
                        position: "relative",
                      }}
                    >
                      <label className="filter_property_label">
                        Owner Name
                      </label>
                      <div className="filter_input_div">
                        <input
                          onClick={() =>
                            setIsOwnerNameInputClicked(!isOwnerNameInputClicked)
                          }
                          className="filter_input"
                          placeholder={
                            !filterData.cityId
                              ? "Select city first"
                              : "Enter Owner Name"
                          }
                          value={filterData.name}
                          onChange={(e) =>
                            handleFilterChange("name", e.target.value)
                          }
                          disabled={!filterData.cityId}
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        />
                      </div>
                      {isOwnerNameInputClicked && (
                        <div
                          ref={ownerRef}
                          style={{
                            position: "absolute",
                            width: "100%",
                            maxHeight: "200px",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            backgroundColor: "white",
                            padding: "5px 10px",
                            overflowY: "auto",
                            zIndex: "999",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          }}
                        >
                          {fetchOwnerNamesLoading ? (
                            <p style={{ color: "black", marginTop: "8px" }}>
                              Loading...
                            </p>
                          ) : (
                            ownerNames?.map((item, idx) => (
                              <p
                                key={idx}
                                style={{
                                  color: "black",
                                  marginTop: "8px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleFilterChange("name", item?.name);
                                  setIsOwnerNameInputClicked(false);
                                }}
                              >
                                {item?.name}
                              </p>
                            ))
                          )}
                        </div>
                      )}
                    </div>

                    {/* Features */}
                    <div style={{ marginTop: "10px" }}>
                      <label className="filter_property_label">Features</label>
                      <div className="filter_input_div">
                        <select
                          disabled={!filterData.cityId}
                          className="filter_input"
                          value={filterData?.features}
                          onChange={(e) =>
                            handleFilterChange("features", e.target.value)
                          }
                          style={{
                            backgroundColor: !filterData.cityId
                              ? "#f5f5f5"
                              : "white",
                          }}
                        >
                          <option value="">--Select Features--</option>
                          <option value="Swimming Pool">Swimming Pool</option>
                          <option value="Gym">Gym</option>
                          <option value="Lift">Lift</option>
                          <option value="Parking">Parking</option>
                        </select>
                      </div>
                    </div>

                    {/* Price Slider */}
                    {renderPriceSlider()}

                    {/* Price Dropdowns */}
                    {isPriceFilterActive && (
                      <div
                        className="form_field_property"
                        style={{ display: "flex", gap: "12px" }}
                      >
                        <div className="filter_input_div" style={{ flex: 1 }}>
                          <select
                            className="filter_input"
                            onChange={(e) =>
                              setMinValue(Number(e.target.value))
                            }
                            value={minValue}
                          >
                            <option value="0">Min Price</option>
                            {priceOptions.map((val) => (
                              <option
                                key={val}
                                value={val}
                                disabled={maxValue !== 0 && val > maxValue}
                              >
                                {formatValue(val)}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="filter_input_div" style={{ flex: 1 }}>
                          <select
                            className="filter_input"
                            onChange={(e) =>
                              setMaxValue(Number(e.target.value))
                            }
                            value={maxValue}
                          >
                            <option value="0">Max Price</option>
                            {priceOptions.map((val) => (
                              <option
                                key={val}
                                value={val}
                                disabled={minValue !== 0 && val < minValue}
                              >
                                {formatValue(val)}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}

                    {/* Clear All Button */}
                    {/* <div className="form_field_property">
                      <button
                        type="button"
                        onClick={handleClearAll}
                        style={{
                          width: "100%",
                          padding: "10px",
                          backgroundColor: "#dc3545",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          cursor: "pointer",
                          marginTop: "10px",
                        }}
                      >
                        Clear All Filters
                      </button>
                    </div> */}
                  </form>
                </div>

                {/* Mobile Filter Modal */}
                {show && (
                  <>
                    <div
                      onClick={() => setshow(!show)}
                      className="modal_filter_div"
                    />
                    <div className="filter_property_div5">
                      <div className="filter_div_head">
                        <p className="filter_by_para">Filter by</p>
                        <p
                          className="clear_all_para"
                          style={{ cursor: "pointer" }}
                          onClick={() => setshow(false)}
                        >
                          Apply
                        </p>
                      </div>
                      <div className="property_filter_form_wrapper">
                        <form>
                          {/* Same filter fields as above - simplified for mobile */}
                          <div className="form_field_property">
                            <label className="filter_property_label">
                              City
                            </label>
                            <div className="filter_input_div">
                              <select
                                className="filter_input"
                                value={filterData?.cityId}
                                onChange={(e) =>
                                  handleFilterChange("cityId", e.target.value)
                                }
                              >
                                <option value="">Select City</option>
                                {city?.map((option) => (
                                  <option value={option._id} key={option._id}>
                                    {option?.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="form_field_property">
                            <label className="filter_property_label">
                              Property Type
                            </label>
                            <div className="filter_input_div">
                              <select
                                className="filter_input"
                                value={filterData?.propertyType}
                                onChange={(e) =>
                                  handleFilterChange(
                                    "propertyType",
                                    e.target.value,
                                  )
                                }
                                disabled={!filterData.cityId}
                              >
                                <option value="">Select Property Type</option>
                                {propertyType?.map((option) => (
                                  <option value={option._id} key={option._id}>
                                    {option?.propertyType}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="form_field_property">
                            <label className="filter_property_label">
                              Available For
                            </label>
                            <div className="filter_input_div">
                              <select
                                className="filter_input"
                                value={filterData?.propertyFor}
                                onChange={(e) =>
                                  handleFilterChange(
                                    "propertyFor",
                                    e.target.value,
                                  )
                                }
                                disabled={!filterData.cityId}
                              >
                                <option value="">Select Available For</option>
                                {availableFor?.map((option) => (
                                  <option
                                    value={option.value}
                                    key={option.value}
                                  >
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="form_field_property">
                            <label className="filter_property_label">BHK</label>
                            <div className="filter_input_div">
                              <select
                                disabled={!filterData.cityId}
                                className="filter_input"
                                value={filterData?.bhk}
                                onChange={(e) =>
                                  handleFilterChange("bhk", e.target.value)
                                }
                              >
                                <option value="">--Select BHK--</option>
                                {[
                                  "0",
                                  "1",
                                  "1RK",
                                  "2",
                                  "2RK",
                                  ...Array.from({ length: 33 }, (_, i) =>
                                    (i + 3).toString(),
                                  ),
                                ]?.map((item) => (
                                  <option value={item} key={item}>
                                    {item}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          {renderPriceSlider()}
                          {/* <div className="form_field_property">
                            <button
                              type="button"
                              onClick={handleClearAll}
                              style={{
                                width: "100%",
                                padding: "10px",
                                backgroundColor: "#dc3545",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                                marginTop: "10px",
                              }}
                            >
                              Clear All Filters
                            </button>
                          </div> */}
                        </form>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .custom-dropdown {
          position: relative;
          width: 100%;
        }
        .filter-input {
          width: 100%;
          padding: 8px 12px;
          border: 1px solid var(--ws-blue-border);
          border-radius: 8px;
          font-size: 14px;
          color:var(--ws-blue-card-for)
        }
        .filter-input:focus {
          outline: none;
          border-color: #007bff;
        }
          .dark .filter-input{
          background:#1f2937;
          border-color:#374151;
          color:#ffffff;
          }
        .dropdown-list {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          max-height: 250px;
          overflow-y: auto;
          background: white;
          border: 1px solid #ddd;
          border-radius: 4px;
          margin-top: 2px;
          z-index: 1000;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }
        .dropdown-item {
          padding: 8px 12px;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        .dropdown-item:hover {
          background-color: #f0f0f0;
        }
        .dropdown-item.selected {
          background-color: #e3f2fd;
          color: #007bff;
        }
        .dropdown-item.no-results {
          color: #999;
          cursor: default;
        }
        .dropdown-item.no-results:hover {
          background-color: white;
        }
        .pagination-container {
          margin: 20px 0;
          display: flex;
          justify-content: center;
          gap: 8px;
        }
        .pagination-btn {
          padding: 8px 12px;
          border: 1px solid #ddd;
          border-radius: 4px;
          cursor: pointer;
        }
        .pagination-btn.active {
          background-color: #007bff;
          color: white;
        }
        .pagination-btn:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }
      `}</style>
    </>
  );
};

export default NewPropertyList;
